<script lang="ts">
  import type {
    IFormTextareaNode,
    PartialNode,
  } from "@shared/common/node/type";
  import { generateFormDataName } from "@shared/common/utils/form";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";
  import { simpleRandomId } from "../../util/common";
  import FormLabel from "./form/form-label.svelte";

  const { reactionEventListener } = getStore();

  const id = simpleRandomId();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<IFormTextareaNode>;

  $: name = generateFormDataName(node);
</script>

<div
  use:detectReaction={{
    node,
    onAction: reactionEventListener,
    documentNode,
  }}
>
  <FormLabel label={node.label} required={node.required} htmlFor={id} />
  <textarea
    {id}
    {name}
    class="form-input"
    placeholder={node.placeholder}
    required={node.required}
  />
</div>

<style>
  /* 참고: front-app 의 editor-node 스타일도 함께 수정 필요 */

  .form-input {
    border-width: 1px;
    border-style: solid;
    border-color: rgba(var(--cb-form-base-color), 1);
    transition-property: border-color;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    border-radius: 4px;
    padding: calc(var(--cb-text-xs) * 0.5) var(--cb-text-sm);
    width: 100%;
    box-sizing: border-box;
    margin-top: calc(var(--cb-form-font-size) * 0.5);
    font-size: var(--cb-text-lg);
    line-height: var(--cb-line-height-lg);
    color: rgba(var(--cb-form-font-color), 1);
    background-color: white;
  }

  .form-input::placeholder {
    color: rgba(var(--cb-form-font-color), 0.6);
  }

  .form-input:focus,
  .form-input:active,
  .form-input:hover {
    outline: none;
    border: 1px solid rgba(var(--cb-form-primary-color), 0.5);
  }
</style>
